import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';

interface SessionExpiredPopupProps {
    isOpen: boolean;
    onClose: () => void;
}
const SessionExpiredPopup: React.FC<SessionExpiredPopupProps> = ({ isOpen, onClose }) => {
    const handleReLogin = () => {
        onClose();
        // clear session

        window.location.pathname = '/login';
    };
    return (
        <Dialog open={isOpen} onClose={onClose}>
            <DialogTitle>Session Expired</DialogTitle>
            <DialogContent>
                <p>Your session has expired. Please log in again.</p>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
                <Button color="primary" onClick={handleReLogin}>
                    Log In
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SessionExpiredPopup;
